import React from "react";
import * as FaIcons from "react-icons/fa";

const R12DassInformation = ({
  formData,
  onFormDataChange,
  validationCheck,
}) => {
  const {
    firstName,
    beenExpelled,
    expelledFromWhichSchool,
    expelledWhatYear,
    beenSuspended,
    suspendedFromWhichSchool,
    suspendedWhatYear,
    onProbation,
    isParentOrExpecting,
    moreThanThreeUnexcusedAbsences,
    lateToSchoolMoreThanThreeTimes,
    orderedToAttendSchool,
    orderedToAttendWhichSchool,
    orderedToAttendWhatYear,
    retainedMoreThanOnce,
    retainedFromWhichSchool,
    retainedFromWhatYear,
    droppedOutOfSchool,
    droppedOutFromWhichSchool,
    droppedOutFromWhatYear,
    behindSemesterInCredits,
    outOfSchoolMoreThanFortyFiveDays,
    expelledMoreThanTwoSchoolsPastYear,
    fosterCare,
    youthExperiencingHomelessness,
  } = formData;
  return (
    <>
      {/* Dass Information */}
      <div className="sub-form">
        <h3>DASS Information</h3>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
               Has {firstName === "" ? " Student" : firstName} Ever Been Expelled
              From Any School for Any Reason?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck && !(beenExpelled["no"] || beenExpelled["yes"])
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={beenExpelled["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="beenExpelled"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={beenExpelled["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="beenExpelled"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>

        {beenExpelled["yes"] && (
          <>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>From Which School</h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="expelledFromWhichSchool"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={expelledFromWhichSchool}
                style={{
                  border:
                    validationCheck && !(expelledFromWhichSchool !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
            </div>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>What Year</h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="expelledWhatYear"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={expelledWhatYear}
                style={{
                  border:
                    validationCheck && !(expelledWhatYear !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
            </div>
          </>
        )}
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              Has {firstName === "" ? " Student" : firstName} Ever Been
              Suspended for More Than 10 Days in Any School Year?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(beenSuspended["yes"] || beenSuspended["no"])
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={beenSuspended["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="beenSuspended"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={beenSuspended["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="beenSuspended"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        {beenSuspended["yes"] && (
          <>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>From Which School</h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="suspendedFromWhichSchool"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={suspendedFromWhichSchool}
                style={{
                  border:
                    validationCheck && !(suspendedFromWhichSchool !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
            </div>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>What Year</h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="suspendedWhatYear"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={suspendedWhatYear}
                style={{
                  border:
                    validationCheck && !(suspendedWhatYear !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
            </div>
          </>
        )}
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
            Is {firstName === "" ? "the Student" : firstName} on Probation?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck && !(onProbation["yes"] || onProbation["no"])
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={onProbation["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="onProbation"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={onProbation["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="onProbation"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
            Is {firstName === "" ? "the Student" : firstName} a Parent (Mother
              or Father) or Expecting a Child Soon?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(isParentOrExpecting["yes"] || isParentOrExpecting["no"])
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={isParentOrExpecting["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="isParentOrExpecting"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={isParentOrExpecting["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="isParentOrExpecting"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
            Has {firstName === "" ? "the Student" : firstName} Had More Than 3
              Unexcused Absences in a School Year?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(
                  moreThanThreeUnexcusedAbsences["yes"] ||
                  moreThanThreeUnexcusedAbsences["no"]
                )
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={moreThanThreeUnexcusedAbsences["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="moreThanThreeUnexcusedAbsences"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={moreThanThreeUnexcusedAbsences["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="moreThanThreeUnexcusedAbsences"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
            Has {firstName === "" ? "the Student" : firstName} Been 30 Minutes
              Late to School 3 or More Times in a School Year?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(
                  lateToSchoolMoreThanThreeTimes["yes"] ||
                  lateToSchoolMoreThanThreeTimes["no"]
                )
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={lateToSchoolMoreThanThreeTimes["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="lateToSchoolMoreThanThreeTimes"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={lateToSchoolMoreThanThreeTimes["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="lateToSchoolMoreThanThreeTimes"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
            Has {firstName === "" ? "the Student" : firstName} Ever Been
              Ordered To Attend School by a Review Board or Probation Officer?{" "}   
               <FaIcons.FaAsterisk className="asterisk-icon" />
            </h4>
         
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(orderedToAttendSchool["yes"] || orderedToAttendSchool["no"])
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={orderedToAttendSchool["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="orderedToAttendSchool"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={orderedToAttendSchool["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="orderedToAttendSchool"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        {orderedToAttendSchool["yes"] && (
          <>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>From Which School</h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="orderedToAttendWhichSchool"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={orderedToAttendWhichSchool}
                style={{
                  border:
                    validationCheck && !(orderedToAttendWhichSchool !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
            </div>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>What Year</h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="orderedToAttendWhatYear"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={orderedToAttendWhatYear}
                style={{
                  border:
                    validationCheck && !(orderedToAttendWhatYear !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
            </div>
          </>
        )}
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
            Was {firstName === "" ? "the Student" : firstName} Retained (Held
              Back) More Than Once in Grades K-8?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(retainedMoreThanOnce["yes"] || retainedMoreThanOnce["no"])
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={retainedMoreThanOnce["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="retainedMoreThanOnce"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={retainedMoreThanOnce["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="retainedMoreThanOnce"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        {retainedMoreThanOnce["yes"] && (
          <>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>From Which School</h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="retainedFromWhichSchool"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={retainedFromWhichSchool}
                style={{
                  border:
                    validationCheck && !(retainedFromWhichSchool !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
            </div>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>What Year</h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="retainedFromWhatYear"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={retainedFromWhatYear}
                style={{
                  border:
                    validationCheck && !(retainedFromWhatYear !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
            </div>
          </>
        )}
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
            Has {firstName === "" ? "the Student" : firstName} Ever Dropped
              Out of School?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(droppedOutOfSchool["yes"] || droppedOutOfSchool["no"])
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={droppedOutOfSchool["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="droppedOutOfSchool"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={droppedOutOfSchool["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="droppedOutOfSchool"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        {droppedOutOfSchool["yes"] && (
          <>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>From Which School</h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="droppedOutFromWhichSchool"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={droppedOutFromWhichSchool}
                style={{
                  border:
                    validationCheck && !(droppedOutFromWhichSchool !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
            </div>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>What Year</h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="droppedOutFromWhatYear"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={droppedOutFromWhatYear}
                style={{
                  border:
                    validationCheck && !(droppedOutFromWhatYear !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
            </div>
          </>
        )}
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
            Is {firstName === "" ? "the Student" : firstName} Behind a
              Semester or More in Credits?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(
                  behindSemesterInCredits["yes"] ||
                  behindSemesterInCredits["no"]
                )
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={behindSemesterInCredits["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="behindSemesterInCredits"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={behindSemesterInCredits["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="behindSemesterInCredits"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
            Has {firstName === "" ? "the Student" : firstName} Been Out of
              School for 45 Days or More Not Including Summer, Holiday Break,
              Off-Track or Any Other Days When a School Is Closed?
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </h4>
            {/* <FaIcons.FaAsterisk className="asterisk-icon" /> */}
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(
                  outOfSchoolMoreThanFortyFiveDays["yes"] ||
                  outOfSchoolMoreThanFortyFiveDays["no"]
                )
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={outOfSchoolMoreThanFortyFiveDays["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="outOfSchoolMoreThanFortyFiveDays"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={outOfSchoolMoreThanFortyFiveDays["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="outOfSchoolMoreThanFortyFiveDays"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
            Has {firstName === "" ? "the Student" : firstName} Been Enrolled
              in More Than 2 Schools During the Past Academic Year or Has
              Changed Schools More Than Two Times Since Entering High School?{" "}
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </h4>
          
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(
                  expelledMoreThanTwoSchoolsPastYear["yes"] ||
                  expelledMoreThanTwoSchoolsPastYear["no"]
                )
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={expelledMoreThanTwoSchoolsPastYear["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="expelledMoreThanTwoSchoolsPastYear"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={expelledMoreThanTwoSchoolsPastYear["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="expelledMoreThanTwoSchoolsPastYear"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
            Is {firstName === "" ? "the Student" : firstName} in Foster Care?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck && !(fosterCare["yes"] || fosterCare["no"])
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={fosterCare["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="fosterCare"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={fosterCare["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="fosterCare"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
            Is {firstName === "" ? "the Student" : firstName} a Youth
              Experiencing Homelessness?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(
                  youthExperiencingHomelessness["yes"] ||
                  youthExperiencingHomelessness["no"]
                )
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={youthExperiencingHomelessness["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="youthExperiencingHomelessness"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={youthExperiencingHomelessness["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="youthExperiencingHomelessness"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default R12DassInformation;
